<template>
  <div>
    <base-loading :visible="isLoading" />
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-full md:col-span-2 md:col-start-11  xs:col-start-1">
        <search-input v-model="search" @search="onSearch" @clear="onSearch" />
      </div>
      <div class="col-span-full col-start-1">
        <notifications-table :items="items" @loadMore="loadMore" @sortChanged="onSortChanged" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useNotifications } from '../composables/use-notifications'
import { useNotifier } from '@/composables/useNotifier'
import NotificationsTable from '../components/NotificationsTable'
import BaseLoading from '@/views/app/components/BaseLoading'
import SearchInput from '@/views/app/components/SearchInput'

const { notify } = useNotifier()

const search = ref('')
const notifications = useNotifications()
const sort = ref({})
const items = computed(() => notifications.state.items)
const currentPage = computed(() => notifications.state.currentPage)
const lastPage = computed(() => notifications.state.lastPage)
const isLoading = computed(() => notifications.state.loading)

const loadData = async (params = {}) => {
  const payload = {
    page: notifications.state.currentPage || 1,
    search: search.value,
    column: sort.value.column,
    order: sort.value.order,
    ...params
  }
  const result = await notifications.getNotifications(payload)
  if (!result.success) notify({ title: 'error', text: 'message_error', color: 'danger' })
}

const loadMore = async () => {
  if (currentPage.value >= lastPage.value) return
  const newPage = notifications.state.currentPage + 1
  await loadData({ page: newPage })
}

const onSearch = async () => {
  await loadData({ page: 1, search: search.value })
}

const onSortChanged = async (sortData) => {
  sort.value.column = sortData.key
  sort.value.order = sortData.order
  await loadData({ column: sort.value.column, order: sort.value.order, page: 1 })
}

onMounted(() => loadData())

</script>
